import axios from 'axios';

// export const API = `http://localhost:8000/api`
export const API = `https://webportal.wanorn.com/backend/api/`

const $api = axios.create({
    withCredentials: true,
    baseURL: API
})

$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    return config;
})

// Response Interceptor (Optional)
$api.interceptors.response.use(
    (response) => {
        // You can handle the response globally here, such as logging
        return response;
    },
    (error) => {
        // Handle response errors globally (e.g. token expiration, network errors)
        if (error.response) {
            // Server responded with a status outside of the 2xx range
            if (error.response.status === 401) {
                // Handle unauthorized (e.g., redirect to login page)
                console.log('Unauthorized request, redirecting to login...');
                // window.location.href = '/login'; // Example redirect
                localStorage.removeItem('token');
                window.location.reload();
            }
        } else if (error.request) {
            // Request was made, but no response received
            console.error('Network Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default $api;
